export const anchorLinks = [
  {
    anchor: 'about',
    alias: '#about',
    title: 'About',
  },
  {
    anchor: 'artists',
    alias: '#artists',
    title: 'Artists',
  },
  {
    anchor: 'events',
    alias: '#events',
    title: 'Events',
  },
  {
    anchor: 'findUs',
    alias: '#findUs',
    title: 'How to Find Us',
  },
];
